import Vue from 'vue';
import { Getter, namespace } from 'vuex-class';
import { storeModules } from '../../../../../../store';
import reportNotificationTypesStore from "../../../../../../store/report/report-notification/define-types.store";
import { NotificationModel } from '../../../../../../models/report';
import { uniqBy } from 'lodash'

const ReportGetter = namespace(storeModules.ReportNotification, Getter);

export class NotificationTaskProcessModel extends Vue {

  /**  */
  @ReportGetter(reportNotificationTypesStore.Get.GET_NOTIFICATIONS) notification: NotificationModel[];

  /** */
  get coListOfNotifications(): NotificationModel[] {
    return this.notification || [];
  }

  get coListOfNotificationsGroup(): any[] {
    let groups = uniqBy(this.notification, (c) => (c.DateTime as any).toLongDate())
    return groups || [];
  }

  getListOfNotifications(group: any) {
    let items = this.notification.filter(c => (c.DateTime as any).toLongDate() == group)
    return items || [];
  }
}